import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className='flex items-center justify-center min-h-screen bg-background'>
        <div className='flex flex-col items-center gap-4'>
          <div className='animate-spin rounded-full h-10 w-10 border-b-2 border-primary' />
          <span className='text-sm text-muted-foreground'>Loading...</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    sessionStorage.setItem('intendedRoute', location.pathname);
    return <Navigate to='/login2' replace />;
  }

  return children;
};

export default ProtectedRoute;
